const PERMISSION_KEY= "core:user";
const PAGE_URL = {
    USER_PAGE: "/admin/core/user"
}

export {PERMISSION_KEY, PAGE_URL}

